import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="nav"
// Used in: website navbar component 'navigation' and 'navigation_no_cta'
// Purpose: toggle menu burger for mobile and tablet
// Explanation: this controller could be combined with modal controller or similar for its toggle and hide overflow functionality
export default class extends Controller {
  static targets = ['menu'];
  connect() {
    console.log('nav controller connected');
  }
  show_menu() {
    this.menuTarget.classList.toggle('hidden');
    // prevent scroll
    document.querySelector('body').classList.toggle('overflow-hidden');
  }
}
